import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { FieldForm } from '@app/src/common/FieldForm';
import { renderInput } from '@app/src/common/Input';
import * as validate from '@app/src/utils/validations';
import {
  FormWrapper,
  ButtonSend,
  FieldWrapper,
  TermsAndConditions,
} from './styled';
import { maxLength } from '@app/src/utils/normalize';
import { renderTextarea } from '@app/src/views/StepOne/form/components/Description/renderTextarea';
import { Title } from '@app/src/common/Title';
import { renderCheckbox } from '@app/src/common/Checkbox';
import { COLORS } from '@app/src/ui';
import { clearLeadData, fetchLead, MessageConfirm } from '@app/src/common/formContact';

interface Props {
  handleSubmit?: Function;
  className?: string;
}

export const Form: React.FC<Props> = ({ handleSubmit, className }) => {
  const { webId } = useParams();
  const dispatch = useDispatch();

  const result = useSelector(state => state.lead.data);
  const isLoading = useSelector(state => state.lead.isFetching);
  const resultPhone = result && result.phone_number;
  const resultEmail = result && result.email;
  const resultWhatsapp = result && result.use_whatsapp;
  const resultUrlDetail = result && result.url_detail;
  const resultName = result && result.user_name;

  useEffect(() => {
    return () => {
      dispatch(clearLeadData());
    }
  }, []);

  const hydrateData = (data) => ({
    'name': data.name,
    'phone_number': data.phone,
    'message': data.message,
    'email': data.email,
    'web_ad_id': Number(webId) || data.id,
    'data_usage': (data.aditionals) ? 1 : 0
  })

  const handleClickSend = (data) => {
    dispatch(fetchLead(hydrateData(data)));
  };

  return (
    <React.Fragment>
      {
        !resultPhone ?
          <FormWrapper className={className}>
            <Title>Contactar</Title>
            <FieldForm
              label="Nombres y Apellidos"
            >
              <Field
                name="name"
                component={renderInput}
                maxLength={40}
                validate={[validate.required, validate.minLength3, validate.onlyLetters]} />
            </FieldForm>
            <FieldForm
              label="Teléfono"
            >
              <Field
                name="phone"
                normalize={maxLength(11)}
                component={renderInput}
                validate={[validate.required, validate.minLength6]} />
            </FieldForm>
            <FieldForm
              label="Correo electrónico"
            >
              <Field
                name="email"
                component={renderInput}
              //validate={[validate.required, validate.email]}
              />
            </FieldForm>
            <FieldForm label="Mensaje">
              <Field
                name="message"
                component={renderTextarea}
                validate={[validate.required]}
              />
            </FieldForm>
            <FieldWrapper>
              <Field
                name="termsAndConditions"
                component={renderCheckbox}
                validate={[validate.required]}
                colorActive={COLORS.BLACK}
                value="terms">
                <TermsAndConditions>
                  He leído y acepto de manera expresa los <a target="_blank" href="/terminos-y-condiciones">Términos y condiciones</a> y la <a target="_blank" href="/politicas-de-privacidad">Política de privacidad.</a>
                </TermsAndConditions>
              </Field>
            </FieldWrapper>
            <input hidden name="id" />
            <FieldWrapper>
              <Field
                name="aditionals"
                component={renderCheckbox}
                colorActive={COLORS.BLACK}
                value="add">
                <TermsAndConditions>
                  Autorizo el uso de mis datos para <a target="_blank" href="/clausula-de-consentimiento-para-fines-adicionales">fines adicionales.</a>
                </TermsAndConditions>
              </Field>
            </FieldWrapper>
            <ButtonSend
              handleClick={handleSubmit(handleClickSend)}
              background="#000"
              color="#fff"
              width={144}
              loading={isLoading}
              disabled={isLoading}
            >Enviar</ButtonSend>
          </FormWrapper>
          :
          <MessageConfirm
            name={resultName}
            email={resultEmail}
            phone={resultPhone}
            useWhatsapp={Boolean(resultWhatsapp) && resultUrlDetail}
          />
      }

    </React.Fragment>
  )
};

const FormContactHoc = reduxForm({
  form: 'formContact',
  initialValues: {
    name: '',
    phone: '',
    email: '',
    message: '',
    TermsAndConditions: false,
    aditionals: false,
    id: null
  }
})(Form);

export { FormContactHoc as FormContact };